import { DataBean } from "../DataBean";

export class Process extends DataBean {
  public async getProcessCatalogPorPropiedades(
    properties: any,
    maxRows: any
  ): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getProcessCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getProcessSubTypeConstantsList(arg: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessSubTypeConstantsList_Number", [arg]);
  }
}
